import api from '../api';

const BASE_URL = '/api/v2/ai-agent-accents';

const AiAgentAccentsApi = {
	getAllAiAccents: ({ page, perPage, title }) =>
		api.get(
			`${BASE_URL}?${page ? `pageNumber=${page}` : ''}${perPage ? `&pageSize=${perPage}` : ''}${
				title ? `&title=${title}` : ''
			}`
		),
	getAiAgentAccent: (aiAgentAccentId) => api.get(`${BASE_URL}/${aiAgentAccentId}`),
	createAiAgentAccent: (payload) => api.post(BASE_URL, payload),
	updateAiAgentAccent: (aiAgentAccentId, payload) =>
		api.patch(`${BASE_URL}/${aiAgentAccentId}`, payload),
	deleteAiAgentAccent: (aiAgentAccentId) => api.delete(`${BASE_URL}/${aiAgentAccentId}`),
};

export default AiAgentAccentsApi;
